import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import Auth from './services/Auth';
import theme from './global/theme'
import Login from './pages/Login'
import Projects from './pages/Projects'
import Logout from './pages/Logout'
import Alarms from './pages/Alarms';
import ChatPusher from './pages/tmp_ChatPusher'

require('./global/globalStyles')

const auth = new Auth();

class App extends Component {
  render() {
    return (
      <ThemeProvider theme={theme}>
        <Router>
          <div>
            <Route
              exact
              path="/"
              render={() =>
                auth.isAuthenticated() ? (
                  auth.isClw() ? (
                    <Redirect to="/projects" />
                  ) : (
                    <Redirect to="/snapshots" />
                  )
                ) : (
                  <Redirect to="/login" />
                )
              }
            />
            <Route path="/login" component={Login} />
            <Route path="/projects" component={Projects} />
            <Route path="/chat_pusher" component={ChatPusher} />
            <Route path="/logout" component={Logout} />
            <Route path="/snapshots" component={Alarms} />
         </div>
        </Router>
      </ThemeProvider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js